import React from "react";
import classNames from "classnames";

import { VStack } from "../VStack/VStack";
import { SpaceStep } from "../FlexLayout/layout.types";
import styles from "./PageSection.module.scss";

interface PageSectionProps extends React.ComponentPropsWithoutRef<"div"> {
    gap?: SpaceStep;
    noPaddingInline?: boolean;
}

/**
 * @purpose Vertical page content section — a VStack with the standard section
 * gap and the page shell's horizontal padding.
 *
 * @example
 * <PageSection>
 *     <PageHeader />
 *     <PageContent />
 * </PageSection>
 */
export const PageSection = ({
    gap = 16,
    noPaddingInline = false,
    className,
    ...props
}: Readonly<PageSectionProps>) => (
    <VStack
        gap={gap}
        className={classNames(
            { [styles.pageSection]: !noPaddingInline },
            className,
        )}
        {...props}
    />
);
